import * as types from './actionTypes';
import {ORIGINATIONS_APP_BASE_URL, WAITING_ROOM_BASE_URL} from '../constants/global';
import {generateURL} from '../api/urlHelper';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function fetchLeads(params, currentUser) {
  return dispatch => {
    return authenticatedFetch(leadsURL(params), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(underwritingJson => {
      const partnerUuid = getPartnerUuid(params, currentUser);
      if (partnerUuid) {
        return authenticatedFetch(waitingRoomLeadsURL(partnerUuid), {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(waitingRoomJson => {
          const mergedLeads = [...underwritingJson, ...waitingRoomJson];
          dispatch(receiveLeads(mergedLeads));
          dispatch(handleLeadsError(false));
        });
      } else {
        dispatch(receiveLeads(underwritingJson));
        dispatch(handleLeadsError(false));
      }
    })
    .catch(() => {
      dispatch(handleLeadsError(true));
    });
  };
}

export function getPartnerUuid(params, currentUser) {
  if (currentUser && currentUser.relationship_uuid) {
    return currentUser.relationship_uuid;
  }

  else if (params && params.partner_uuid) {
    return params.partner_uuid;
  }
}

export function receiveLeads(json) {
  return {
    type: types.RECEIVE_LEADS,
    leads: json
  };
}

export function handleLeadsError(bool) {
  return {
    type: types.HANDLE_LEADS_ERROR,
    leadsError: bool
  };
}

export function leadsURL(params) {
  let url = `${ORIGINATIONS_APP_BASE_URL()}leads?recent=true`;
  return generateURL(url, params);
}

export function waitingRoomLeadsURL(partner_uuid) {
  if (!partner_uuid) {
    return;
  }

  let url = `${WAITING_ROOM_BASE_URL()}api/v1/partners/${partner_uuid}/leads`;
  return generateURL(url);
}
